import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import { PAYMENT_METHODS } from '../../../constants/payments'
import CheckPoint from '../../icons/CheckPoint'
import Logo from '../../icons/Logo'

const BuyHeader = ({
  onLogoClick,
  phase,
  router,
  type,
  last,
  helper,
  phoneNumber,
}) => (
  <header className="hide-print">
    <div className="header__container">
      <div className="header__left">
        <div className="header__back" onClick={() => router.goBack()}>
          <span></span>
        </div>
        <a className="header__logo" onClick={onLogoClick} title="brumbrum">
          <Logo />
        </a>
      </div>

      <div
        className={`header__middle ${
          phase <= 0 ? 'header__middle--hidden' : ''
        }`}
      >
        <a
          className="only-mobile"
          href={`tel:${phoneNumber}`}
          title="Servizio Clienti"
        >
          <i className="icon-phone-bold"></i>
          <span>&nbsp;&nbsp;02.800.29</span>
        </a>

        <div className="process_menu">
          <ul>
            {phase < 100 && (
              <li className="level0">
                <Link
                  className={`${
                    phase === 10
                      ? 'current'
                      : last >= 10
                      ? 'clickable'
                      : 'disabled'
                  } ${phase >= 10 ? 'active' : ''}`}
                  title="Riepilogo ordine"
                  to={'/cart'}
                >
                  <span>
                    <CheckPoint />
                    Riepilogo ordine
                  </span>
                </Link>
              </li>
            )}

            {phase < 100 && (
              <li className="level0">
                <Link
                  className={`${
                    phase === 15
                      ? 'current'
                      : last >= 10
                      ? 'clickable'
                      : 'disabled'
                  } ${phase >= 15 ? 'active' : ''}`}
                  title="Servizi"
                  to={'/servizi'}
                >
                  <span>
                    <CheckPoint />
                    Servizi
                  </span>
                </Link>
              </li>
            )}

            {phase < 100 && (
              <li className="level0">
                <Link
                  className={`${
                    phase === 20
                      ? 'current'
                      : last >= 10
                      ? 'clickable'
                      : 'disabled'
                  }  ${phase >= 20 ? 'active' : ''}`}
                  title="Checkout"
                  to={'/checkout'}
                >
                  <span>
                    <CheckPoint />
                    Checkout
                  </span>
                </Link>
              </li>
            )}
            {type === PAYMENT_METHODS.NONE && (
              <li className="level0">
                <Link
                  className={'disabled'}
                  style={{ pointerEvents: 'none' }}
                  title="Passaggio di proprietà"
                  to={'/dati'}
                >
                  <span>
                    <CheckPoint />
                    Passaggio di proprietà
                  </span>
                </Link>
              </li>
            )}
            {type === PAYMENT_METHODS.BANK && (
              <li
                className="level0"
                style={last >= 20 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 30
                      ? 'current'
                      : last >= 20
                      ? 'clickable'
                      : 'disabled'
                  } ${phase >= 30 ? 'active' : ''}`}
                  title="Passaggio di proprietà"
                  to={'/dati'}
                >
                  <span>
                    <CheckPoint />
                    Passaggio di proprietà
                  </span>
                </Link>
              </li>
            )}

            {type === PAYMENT_METHODS.BANK && (
              <li
                className="level0"
                style={last >= 20 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 35
                      ? 'current'
                      : last >= 30
                      ? 'clickable'
                      : 'disabled'
                  } ${phase >= 35 ? 'active' : ''}`}
                  title="Proposta contr."
                  to={'/preview-contratto'}
                >
                  <span>
                    <CheckPoint />
                    Proposta contr.
                  </span>
                </Link>
              </li>
            )}
            {type === PAYMENT_METHODS.BANK && (
              <li
                className="level0"
                style={last >= 20 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 40
                      ? 'current'
                      : last >= 30
                      ? 'clickable'
                      : 'disabled'
                  } ${phase >= 40 ? 'active' : ''}`}
                  title="Pagamento"
                  to={'/bonifico'}
                >
                  <span>
                    <CheckPoint />
                    Pagamento
                  </span>
                </Link>
              </li>
            )}
            {type === PAYMENT_METHODS.BANK && (
              <li
                className="level0 hide-md"
                style={last >= 20 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 50
                      ? 'current'
                      : last >= 40
                      ? 'clickable'
                      : 'disabled'
                  } ${phase >= 50 ? 'active' : ''}`}
                  title="Upload documenti"
                  to={'/documents'}
                >
                  <span>
                    <CheckPoint />
                    Upload documenti
                  </span>
                </Link>
              </li>
            )}

            {type === PAYMENT_METHODS.FINANCING && (
              <li
                className="level0"
                style={last >= 20 ? null : { display: 'none' }}
              >
                <Link
                  className={
                    phase === 30
                      ? 'current'
                      : last >= 20
                      ? 'clickable'
                      : 'disabled'
                  }
                  title="Richiesta finanziamento"
                  to={'/dati-finanziamento'}
                >
                  <span>Richiesta finanziamento</span>
                </Link>
              </li>
            )}
            {type === PAYMENT_METHODS.FINANCING && (
              <li
                className="level0"
                style={last >= 20 ? null : { display: 'none' }}
              >
                <Link
                  className={
                    phase === 50
                      ? 'current'
                      : last >= 30
                      ? 'clickable'
                      : 'disabled'
                  }
                  title="Upload documenti"
                  to={'/documents-compass'}
                >
                  <span>Upload documenti</span>
                </Link>
              </li>
            )}
            {type === PAYMENT_METHODS.FINDOMESTIC_FINANCING && phase < 105 ? (
              <li
                className="level0"
                style={last >= 100 ? null : { display: 'none' }}
              >
                <Link
                  className={phase === 110 ? 'current' : 'disabled'}
                  style={{ pointerEvents: 'none' }}
                  title="Certificato Infocert"
                  to={'/certificato-infocert'}
                >
                  <span>Certificato InfoCert</span>
                </Link>
              </li>
            ) : null}

            {type === PAYMENT_METHODS.FINDOMESTIC_FINANCING && phase < 110 && (
              <li
                className="level0"
                style={last >= 20 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 30
                      ? 'current'
                      : last >= 20
                      ? 'clickable'
                      : 'disabled'
                  } ${phase >= 30 ? 'active' : ''}`}
                  title="Richiesta prestito"
                  to={'/dati-finanziamento'}
                >
                  <span>
                    <CheckPoint />
                    Richiesta prestito
                  </span>
                </Link>
              </li>
            )}

            {type === PAYMENT_METHODS.FINDOMESTIC_FINANCING && phase < 110 && (
              <li
                className="level0"
                style={last >= 20 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 40
                      ? 'current'
                      : last >= 30
                      ? 'clickable'
                      : 'disabled'
                  } ${phase >= 40 ? 'active' : ''}`}
                  title="Riepilogo"
                  to={'/riepilogo-finanziamento'}
                >
                  <span>
                    <CheckPoint />
                    Riepilogo
                  </span>
                </Link>
              </li>
            )}

            {type === PAYMENT_METHODS.FINDOMESTIC_FINANCING && phase < 110 && (
              <li
                className="level0"
                style={last >= 20 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 50
                      ? 'current'
                      : last >= 30
                      ? 'clickable'
                      : 'disabled'
                  } ${phase >= 50 ? 'active' : ''}`}
                  title="Upload documenti"
                  to={'/documents'}
                >
                  <span>
                    <CheckPoint />
                    Upload documenti
                  </span>
                </Link>
              </li>
            )}

            {type === PAYMENT_METHODS.FINDOMESTIC_FINANCING && phase > 105 && (
              <li
                className="level0"
                style={last >= 100 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 110
                      ? 'current'
                      : last >= 100
                      ? 'clickable'
                      : 'disabled'
                  }`}
                  title="Contratto Inforcert"
                  to={'/contratto-infocert'}
                >
                  <span>
                    <CheckPoint />
                    Contratto InfoCert
                  </span>
                </Link>
              </li>
            )}

            {type === PAYMENT_METHODS.FINDOMESTIC_FINANCING && phase > 105 && (
              <li
                className="level0"
                style={last >= 100 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 140
                      ? 'current'
                      : last >= 110
                      ? 'clickable'
                      : 'disabled'
                  }`}
                  title="Contratto Findomestic"
                  to={'/contratto-findomestic'}
                >
                  <span>
                    <CheckPoint />
                    Contratto Findomestic
                  </span>
                </Link>
              </li>
            )}

            {type === PAYMENT_METHODS.FINDOMESTIC_FINANCING && phase > 105 && (
              <li
                className="level0"
                style={last >= 100 ? null : { display: 'none' }}
              >
                <Link
                  className={`${
                    phase === 150
                      ? 'current'
                      : last >= 140
                      ? 'clickable'
                      : 'disabled'
                  }`}
                  title="Firma Digitale"
                  to={'/firma-digitale'}
                >
                  <span>
                    <CheckPoint />
                    Firma Digitale
                  </span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="header__right">
        <div className="header--item">
          <ul>
            <li className="level0">
              <a
                className="js-support-hover phone-link"
                href={`tel:${phoneNumber}`}
                title="Servizio Clienti"
              >
                <i className="icon-phone-bold" />
                <span>&nbsp;&nbsp;02.800.29</span>
              </a>
            </li>
            <li
              className="level0 process_menu_guide"
              style={
                [30, 40, 50].indexOf(phase) > -1
                  ? { display: '' }
                  : { display: 'none' }
              }
            >
              <div className="needhelp">
                <div className="needhelp__view-guide">
                  <a className="needhelp__link js-open-guide" onClick={helper}>
                    <i className="icon-book" /> Aiuto
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
)

BuyHeader.propTypes = {
  onLogoClick: PropTypes.func,
  phase: PropTypes.number.isRequired,
  last: PropTypes.number.isRequired,
  helper: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  can_sign: PropTypes.bool,
}

const mapStateToProps = state => ({
  phoneNumber: state.ui.settings.phoneNumber,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(BuyHeader)
